// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1343":"72b2ee40f9982890","28398":"b6323009d4472833","48846":"6438dbb375600f1b","73527":"e2745835eec2cb6b"}[chunkId] + ".css";
};